function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7.06664 7.01771L5.71855 8.25377C5.33861 8.60213 4.74821 8.57653 4.39985 8.1966C4.05149 7.81667 4.07709 7.22627 4.45703 6.87791L7.17751 4.38351C7.63491 3.96412 8.3366 3.96265 8.79575 4.38012L11.5401 6.87527C11.9214 7.22204 11.9495 7.81232 11.6027 8.19371C11.256 8.57511 10.6657 8.60317 10.2843 8.25641L8.93331 7.02807V11.0931C8.93332 11.6086 8.51545 12.0264 7.99999 12.0264C7.48452 12.0264 7.06665 11.6086 7.06665 11.0931L7.06664 7.01771Z",
  fill: "#317AD0"
});
function SvgAiChatSendIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiChatSendIcon);
export default __webpack_public_path__ + "static/media/ai-chat-send-icon.babba4e7.svg";
export { ForwardRef as ReactComponent };